import { render, staticRenderFns } from "./consulta-autorizacao.vue?vue&type=template&id=777466df"
import script from "./consulta-autorizacao.vue?vue&type=script&lang=ts"
export * from "./consulta-autorizacao.vue?vue&type=script&lang=ts"
import style0 from "./consulta-autorizacao.vue?vue&type=style&index=0&id=777466df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports